import DotInspectionContainer from './containers/DotInspectionContainer';

export default DotInspectionContainer;
export {uiDataDotInspection, serverDataDotInspection} from './reducers/DotInspectionReducer';

